import isNil from 'lodash/isNil'

export const NumberWithCommas = (x, percentage = false) => {
  const string = !isNil(x) && x.toString()
  const isPercentage = percentage || string?.includes('%')

  if (isPercentage) {
    const float = parseFloat(string)
    const hasDecimals = float % 1 !== 0

    return (hasDecimals ? float.toFixed(2) : float) + '%'
  }

  return string ? (string.charAt(0) === '0' ? string : string.replace(/\B(?=(\d{3})+(?!\d))/g, ',')) : ''
}

export const PrefixSuffixFormatter = function (scope, percentage = false) {
  return (
    scope.x +
    '<br />' +
    scope.points
      .map(point => {
        const suffix = point.series.name.toLowerCase().includes('conversion') && point.series.tooltipOptions.valueSuffix === '%' // Only apply '%' to series containing 'conversion'
          ? point.series.tooltipOptions.valueSuffix
          : point.series.tooltipOptions.valueSuffix === '%'
            ? ''
            : point.series.tooltipOptions.valueSuffix || ''
        return `<span style="color:${point.color}">\u25CF</span> 
          ${point.series.name}: ${point.series.tooltipOptions.valuePrefix || ''}${NumberWithCommas(point.y + suffix, percentage)}`
      })
      .join('<br />')
  )
}

export const getS = xs => (xs.length === 1 ? '' : 's')
